(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('stockPlace', {
        templateUrl: 'views/components/views/stockPlace/stockPlace.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'utilityService', 'modalService', 'stateService', 'translateService', 'economyService', 'stockPlaceService', 'logisticService', 'factoriesService', 'typeaheadService', function ($stateParams, utilityService, modalService, stateService, translateService, economyService, stockPlaceService, logisticService, factoriesService, typeaheadService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let stockPlaceId = $stateParams.stockplace_id;
            
            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                businessSiteButtons: [
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('businesssites') }
                ],
                factoryButtons: [
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('factories') }
                ],
                edit: {},
                selectListBusinessSites: [],
                selectListBusinessCompanies: [],
                selectListFactories: [],
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE FUNCTION CALLS
            
            async function loadEdit() {
                vm.model.edit = (await stockPlaceService.getEdit({ stockplace_id: stockPlaceId }))[0];

                return loadFactories();
            }

            async function loadCompanies() {
                vm.model.selectListBusinessCompanies = await logisticService.listCompanies();
            }

            async function loadBusinessSites() {
                vm.model.selectListBusinessSites = await economyService.listBusinessSites();
            }
            
            async function loadFactories() {
                if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;
                
                return vm.model.selectListFactories = await factoriesService.listFactories(vm.model.edit.businessco_no);
            }
            
    		// #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            vm.typeaheadSearch = function (value, id) {
                switch (id) {
                    case 'cust_name':
                        vm.model.edit[id] = value;

                        return typeaheadService.searchCustomer({
                            cust_name: vm.model.edit[id] || '',
                            filtertype: '',
                            filtervalue: '',
                            custtype: 'S',
                            lastselect: 'SEARCH'
                        });
                        break;
                    default:
                        break;
                }
            };

            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            // #region SELECTED VALUE FUNCTION

            vm.onTypeaheadSelected = function (item, id) {
                switch (id) {
                    case 'cust_name':
                        if (item) {
                            vm.model.edit.cust_no = item?.item_id ?? '0';
                            vm.model.edit.cust_name = item?.item_name ?? '';
                        } else {
                            vm.onTypeaheadClear('cust_name');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion SELECTED VALUE FUNCTION

            // #region CHANGED VALUE FUNCTION

            vm.onTypeaheadChanged = function (value, item, id) {
                switch (id) {
                    case 'cust_name':
                        vm.model.edit.cust_name = value;

                        if (value) {
                            if (item?.item_id) {
                                vm.model.edit.cust_no = item.item_id;
                            }
                        } else {
                            vm.onTypeaheadClear('cust_name');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion CHANGED VALUE FUNCTION

            // #region CLEAR VALUE FUNCTION

            vm.onTypeaheadClear = function (id) {
                switch (id) {
                    case 'cust_name':
                        vm.model.edit.cust_no = '0';
                        vm.model.edit.cust_name = '';
                        break;
                    default:
                        break;
                }
            };

            // #endregion CLEAR VALUE FUNCTION

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                stockPlaceService.saveObj(vm.model.edit).then(function (response) {
                    if (response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'businessco_no':
                        if (utilityService.validateWatchValue(value, vm.model.edit.businessco_no) !== true) return;

                        vm.model.edit.businessco_no = value;

                        if (utilityService.validateParmsValue(vm.model.edit.businessco_no) !== true) return;

                        loadFactories();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadEdit();
                loadCompanies();
                loadBusinessSites();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
